import { render, staticRenderFns } from "./emptyPage.vue?vue&type=template&id=6df3e392&scoped=true"
import script from "./emptyPage.vue?vue&type=script&lang=ts"
export * from "./emptyPage.vue?vue&type=script&lang=ts"
import style0 from "./emptyPage.vue?vue&type=style&index=0&id=6df3e392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df3e392",
  null
  
)

export default component.exports